import "../components/static";
import Toggle from "./modules/Toggle";
import { moduleFactory } from "./lib";

window.myApp = window.myApp || {};

window.addEventListener("DOMContentLoaded", () => {
  window.myApp.toggles = moduleFactory(Toggle, "[data-toggle]");
});
